import { useFormik } from 'formik'
import { FC, useMemo } from 'react'
import { GrupoDtoCreate, GrupoDtoUpdate, GrupoView } from '../../core/_models'
import { grupoSchema } from './validation/grupoSchema'
import { createGrupo, updateGrupo } from '../../core/_requests'
import { useT } from '_metronic/i18n/Metronici18n'
import { showAlert, showError, ButtonType } from '_metronic/helpers'
import {
  Button,
  FetchState,
  FormInput,
  ListLoading,
  LoadingIndicator,
  useModal,
} from 'app/components'

export const GrupoModal: FC = () => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()

  const { data: grupo } = (fetchStates['grupo'] || {}) as FetchState<GrupoView>

  const initialValues = {
    nome: grupo?.nome || '',
    descricao: grupo?.descricao || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: useMemo(() => grupoSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (grupo?.id) {
          const data: GrupoDtoUpdate = {
            descricao: values.descricao,
          }
          await updateGrupo(grupo.id, data)
        } else {
          const data: GrupoDtoCreate = {
            nome: values.nome,
            descricao: values.descricao,
          }
          await createGrupo(data)
        }

        await showAlert({
          title: t('common.success'),
          text: grupo?.id
            ? t('alert.update', { name: t('grupo.label'), gender: t('grupo.gender') })
            : t('alert.create', { name: t('grupo.label'), gender: t('grupo.gender') }),
          icon: 'success',
        })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            name='nome'
            entity='nome'
            className='mb-3'
            isDisabled={formik.isSubmitting || !!grupo?.id}
            isRequired
          />
        </div>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            name='descricao'
            entity='descricao'
            className='mb-3'
            isRequired
          />
        </div>
      </div>
      <div className='d-flex justify-content-center mt-8'>
        <Button
          type={ButtonType.Reset}
          onClick={closeModal}
          className='btn-secondary me-3'
          disabled={formik.isSubmitting}
        >
          {t('common.cancel')}
        </Button>

        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
      {formik.isSubmitting && <ListLoading />}
    </form>
  )
}
